/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClaimReservationCommunicationMethod = {
    EMAIL: 'EMAIL',
    PHONE: 'PHONE',
    unknown_default_open_api: '11184809'
} as const;
export type ClaimReservationCommunicationMethod = typeof ClaimReservationCommunicationMethod[keyof typeof ClaimReservationCommunicationMethod];


export function instanceOfClaimReservationCommunicationMethod(value: any): boolean {
    for (const key in ClaimReservationCommunicationMethod) {
        if (Object.prototype.hasOwnProperty.call(ClaimReservationCommunicationMethod, key)) {
            if (ClaimReservationCommunicationMethod[key as keyof typeof ClaimReservationCommunicationMethod] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClaimReservationCommunicationMethodFromJSON(json: any): ClaimReservationCommunicationMethod {
    return ClaimReservationCommunicationMethodFromJSONTyped(json, false);
}

export function ClaimReservationCommunicationMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimReservationCommunicationMethod {
    return json as ClaimReservationCommunicationMethod;
}

export function ClaimReservationCommunicationMethodToJSON(value?: ClaimReservationCommunicationMethod | null): any {
    return value as any;
}

